"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterRef = exports.ParameterDef = void 0;
var expression_1 = require("./expression");
var builder_1 = require("./builder");
var ParameterDef = /** @class */ (function (_super) {
    __extends(ParameterDef, _super);
    function ParameterDef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.default = (0, builder_1.build)(json.default);
        _this.parameterTypeSpecifier = json.parameterTypeSpecifier;
        return _this;
    }
    ParameterDef.prototype.exec = function (ctx) {
        // If context parameters contains the name, return value.
        if (ctx && ctx.parameters[this.name] !== undefined) {
            return ctx.parameters[this.name];
            // If the parent context contains the name, return that
        }
        else if (ctx.getParentParameter(this.name) !== undefined) {
            var parentParam = ctx.getParentParameter(this.name);
            return parentParam.default != null ? parentParam.default.execute(ctx) : parentParam;
            // If default type exists, execute the default type
        }
        else if (this.default != null) {
            this.default.execute(ctx);
        }
    };
    return ParameterDef;
}(expression_1.Expression));
exports.ParameterDef = ParameterDef;
var ParameterRef = /** @class */ (function (_super) {
    __extends(ParameterRef, _super);
    function ParameterRef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.library = json.libraryName;
        return _this;
    }
    ParameterRef.prototype.exec = function (ctx) {
        ctx = this.library ? ctx.getLibraryContext(this.library) : ctx;
        var param = ctx.getParameter(this.name);
        return param != null ? param.execute(ctx) : undefined;
    };
    return ParameterRef;
}(expression_1.Expression));
exports.ParameterRef = ParameterRef;
//# sourceMappingURL=parameters.js.map